import theme from "./theme.json";

// console.log('theme', theme)

export default {
    global_primary_color: theme["primary-color"]
};
